import { RestockingState } from 'src/features/restocking/RestockingTypes'
import Header from '../Header/Header'
import * as S from './Page.styles'
import { useSelector } from 'src/utils/store'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { initialState } from 'src/features/restocking/RestockingState'

interface PageProps {
  children: React.ReactNode;
  headerTitle: string;
  goBackRoute?: string;
  propertyToClear?: keyof RestockingState | (keyof RestockingState)[]
  hasBackButton?: boolean
  isRestocking?: boolean
}

const Page: React.FC<PageProps> = ({
  children, headerTitle, goBackRoute, propertyToClear, hasBackButton, isRestocking,
}) => {
  const { user } = useSelector((state) => state.restocking)
  const history = useHistory()

  useEffect(() => {
    if (user === initialState.user) {
      history.push('/restocking/webapp/badge')
    }
  }, [history, user])

  return (
    <S.PageContainer isRestocking={isRestocking}>
      <Header
        title={headerTitle}
        goBackRoute={goBackRoute}
        propertyToClear={propertyToClear}
        hasBackButton={hasBackButton}
      />
      {children}
    </S.PageContainer>
  )
}

export default Page
